import {
  Send,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {  AuthContext, PosizionamentoContext } from "../contexts";
import { useForm } from "../hooks";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { TableRowHtml } from "../components";
import { green } from '@mui/material/colors';

  const MagLogCustomDettaglio = (props) => {
    const navigate = useNavigate()
    const {codiceMenu, prgMovimento } = useParams();
    const [customCol, setCustomCol] = React.useState([]);
    const [loadingConfermaMovimento, setLoadingConfermaMovimento] = React.useState(false);

  
    const inputRef = React.useRef();

    const  {
        state : {
            MovimentoColumns,
            movimento,
            infoMovimento,
        },

        getMagMovimDataCustom,
        postRegistraMovimentoCustom,
        postConfermaMovimentoCustom

    } = useContext(PosizionamentoContext);



    const {
      state:{      
        visibleMenu,
      },
  
    } = useContext(AuthContext);


  
    useEffect(() => {
      if (prgMovimento) {
        
        getMagMovimDataCustom(codiceMenu, prgMovimento,  navigate);
      }
    }, []);
  
    const validations = [];
    const {
      values: articoloForm,
      changeHandler,
      setValues,
    } = useForm(
      {
        Articolo: "",
        Ubicazione:"",
      },
      validations
    );
  
  
  
    React.useEffect(() => {
      let colonneDaModificare = [];
      if (MovimentoColumns){
        MovimentoColumns.map((res, i) => {
          colonneDaModificare = [
            ...colonneDaModificare,
            {
              field: res.id,
              headerName: res.label,
              minWidth: res.minWidth,
            },
          ];
        });
        setCustomCol(colonneDaModificare);
      }
    }, [MovimentoColumns]);
  
    const onkeyEnter = (event) => {
      if (event === 13) {
        saveData();
      }
    };
  
    const saveData = () => {  
      postRegistraMovimentoCustom(codiceMenu,prgMovimento, articoloForm);

      clearForm(); 
      // setTimeout(() => {
      //   inputRef.current.focus();
      // }, 100);      
    }
  

    const clearForm = () => {    
      setValues({
        Articolo: "",
        Ubicazione:"",
      });
    }
  
  

  const confermaMovimentoActive = () => {
    let confermaMovimentoActive = false;
    visibleMenu.forEach((element) => {
      if ( element.codiceMenu === codiceMenu ){
        console.log('element', element);
        if (element.confermaMovimentoActive === true) {
          confermaMovimentoActive = true;
        }
      }
    });

    return (confermaMovimentoActive);
  }
  
    return (
      <Grid container>
        <Grid
          container
          sx={{
            position: "fixed",
            background: (theme) => theme.palette.background.paper,
          }}
        >
          <TextField
            id="outlined-basic"
            label="Barcode"
            variant="outlined"
            placeholder="Inserire il barcode"
            fullWidth
            autoFocus
            autoComplete="off"
            inputRef={inputRef}
            onChange={(e) => changeHandler("Ubicazione", e.target.value)}
            value={articoloForm.Ubicazione || ""}
            onKeyPress={(e) => onkeyEnter(e.charCode)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    variant="contained"
                    color="secondary"
                    onClick={() => saveData()}
                  >
                    <Send />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
  
        <Grid container mt={8}>
          <Grid item xs={12} md={6} lg={6}>
            <Alert severity="info" component="span">
              {
                <ReactMarkdown
                  children={
                    infoMovimento !== ''
                      ? infoMovimento
                      : " "
                  }
                  rehypePlugins={[rehypeRaw]}
                ></ReactMarkdown>
              }{" "}
            </Alert>
            <Alert severity="warning" component="span">
              {
                <ReactMarkdown
                  children={
                    infoMovimento?.summarytext
                      ? infoMovimento.summarytext.toString()
                      : " "
                  }
                  rehypePlugins={[rehypeRaw]}
                ></ReactMarkdown>
              }
            </Alert>
            <Grid item xs={12} md={12} lg={12}>
              {customCol?.length > 0 ? (
                <TableRowHtml customCol={customCol} rows={movimento} />
              ) : (
                <></>
              )}
            </Grid>
  
          </Grid>
          
        </Grid> 
        { confermaMovimentoActive() === true ?
        <Box sx={{position:'relative'}}>
          <Button
            onClick={() => {postConfermaMovimentoCustom(codiceMenu,prgMovimento, navigate, setLoadingConfermaMovimento )}}
            variant="contained"
            sx={{ml:1, mt:1}}
            disabled={loadingConfermaMovimento}
          >
             Conferma movimento
          </Button>

          {loadingConfermaMovimento && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
              }}
            />
          )}

        </Box>
        : <></>
        }
      </Grid>
    );
  };
  
  export default MagLogCustomDettaglio;
  